export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Assistant IA"])}
      },
      "en": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI Assistant"])}
      }
    }
  })
}
